module.exports = __webpack_public_path__ + "img/logo.ad73c697.png";